import React from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import {
    FL_DESCRIPTION, FL_INCLUDE, FL_INFO_WINDOW,
    FL_TERMS_AND_CONDS,
} from "../../../components/i18n/formLabels";
import {
    PH_DESCRIPTION, PH_INCLUDE,
    PH_INFO_WINDOW,
    PH_TERMS_AND_CONDS,
} from "../../../components/i18n/placeHolders";

import {FL_TITLE} from "../../../components/i18n/formLabels";
import {PH_TITLE} from "../../../components/i18n/placeHolders";
import {LangController} from "../../../components/tabs/langController";

const PromotionControllerLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            lang: { id:lang?.id, name:lang?.name },
            title: '',
            name: '',
            description: '',
            terms: '',
            included: '',
            warning: '',
            months: '',
            purchaseDiscount: '',
            infoWindow: '',
            validity: '',
            id: '',
        }) )
        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{FL_TITLE}</Label>
                    <Input
                        type="text"
                        name="title"
                        placeholder={PH_TITLE}
                        value= { child.title || '' }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_DESCRIPTION }</Label>
                    <Input type="textarea" name="description"
                           rows="2"
                           placeholder={ PH_DESCRIPTION }
                           value= { child.description || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label >{ 'Periodo de validez' }</Label>
                    <Input type="textarea" name="validity"
                           rows="8"
                           placeholder={ PH_DESCRIPTION }
                           value= { child.validity || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label >{ FL_TERMS_AND_CONDS }</Label>
                    <Input type="textarea" name="terms"
                           rows="8"
                           placeholder={ PH_TERMS_AND_CONDS }
                           value= { child.terms || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label >{ FL_INFO_WINDOW }</Label>
                    <Input type="textarea" name="infoWindow"
                           rows="10"
                           placeholder={ PH_INFO_WINDOW }
                           value= { child.infoWindow || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label >{ FL_INCLUDE }</Label>
                    <Input type="textarea" name="included"
                           rows="10"
                           placeholder={ PH_INCLUDE }
                           value= { child.included || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
    />)
}

export default PromotionControllerLangs;
